import { ToggleButtons } from "../buttons";
import { Icon } from "../icons";
import { FONT_SIZES } from "../../theme";

interface GroupedViewToggleProps {
    isGrouped: boolean;
    onChange: (isGrouped: boolean) => void;
}

const ICON_SX = { height: FONT_SIZES.body2, width: FONT_SIZES.body2 };

/**
 * Pill toggle for swapping between grouped and flat views of the same data.
 * Mounted inside `Toolbar` when `showViewToggle` is true. Consumer controls
 * the actual mode by conditionally passing `grouping` to `Table`; this widget
 * just reports flips via `onChange`.
 */
export function GroupedViewToggle({ isGrouped, onChange }: GroupedViewToggleProps) {
    return (
        <ToggleButtons
            value={isGrouped ? 1 : 0}
            setValue={(val) => onChange(!!val)}
            size="small"
            options={[
                { value: 0, label: <Icon type="list" sx={ICON_SX} /> },
                { value: 1, label: <Icon type="grouped-list" sx={ICON_SX} /> }
            ]}
        />
    );
}
